import { render, staticRenderFns } from "./jobs-social.vue?vue&type=template&id=41a05ed8&scoped=true&"
import script from "./jobs-social.vue?vue&type=script&lang=js&"
export * from "./jobs-social.vue?vue&type=script&lang=js&"
import style0 from "./jobs-social.vue?vue&type=style&index=0&id=41a05ed8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a05ed8",
  null
  
)

export default component.exports